import loadConfig from '../config'
import Vue from 'vue'
import App from './App.vue'
import store from './store'

Vue.config.productionTip = false
Vue.prototype.$config = loadConfig(process.env.VUE_APP_CONFIG)

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
